import axios from "axios";
import dayjs from "dayjs";
import AddressDetail from "../../../utils/AddressDetail";
import { ApiUrl } from "../../../utils/ApiUrl";
import { CheckTerminal } from "../../../utils/CheckTerminal";

export const reqBooking = async (value: any) => {
  var fromRequestDatas: any = [];
  var toRequestDatas: any = [];

  //check Address detail in One Map API
  fromRequestDatas = await AddressDetail(value.from);

  if (value.hotelAddress) {
    toRequestDatas = await AddressDetail(value.hotelAddress);
  }

  return axios
    .request({
      method: "POST",
      url: `${ApiUrl}/bookingsBySchedule`,
      data: {
        pickUpTime: dayjs(value.date).format("YYYY-MM-DD"),
        adultTotal: value.adults,
        childTotal: value.childs || 0,
        numberOfBags: value.bags,
        flightNumber: value.flightnumber,
        type: 0,
        bookingMethod: 3,
        scheduleId: value.scheduleId,
        bookingLocations: [
          {
            name: CheckTerminal(value.from, true),
            address: {
              street: CheckTerminal(value.from, true),
              unitNumber: "0",
              blockNumber: fromRequestDatas.BLK_NO,
              building: fromRequestDatas.BUILDING,
              postalCode: fromRequestDatas.POSTAL,
              fullAddress: CheckTerminal(value.from, true),
              lat: parseFloat(fromRequestDatas.LATITUDE),
              lng: parseFloat(fromRequestDatas.LONGITUDE),
            },
            description: value.descriptions ? value.descriptions : "-",
            order: 0,
          },
          {
            name: value.to,
            address: {
              street: value.hotelAddress,
              unitNumber: "0",
              blockNumber: toRequestDatas?.BLK_NO,
              building: value.to,
              postalCode: toRequestDatas?.POSTAL,
              fullAddress: value.hotelAddress,
              lat: toRequestDatas?.LATITUDE
                ? parseFloat(toRequestDatas?.LATITUDE)
                : 0.0,
              lng: toRequestDatas?.LONGITUDE
                ? parseFloat(toRequestDatas?.LONGITUDE)
                : 0.0,
            },
            description: value.descriptions ? value.descriptions : "-",
            order: 1,
          },
        ],
        customer: {
          name: value.name,
          email: value.email,
          contact: value.contactnumber,
        },
      },
      headers: { "Content-Type": "application/json", charset: "utf-8" },
    })
    .then((res) => {
      if (res.status === 200) {
        return res;
      }
    })
    .catch((e) => {
      return e?.response?.data?.message || "Something went wrong";
    });

  /* The above code is making a POST request to the API endpoint. */
};
